<template>
    <div>
        <transition-group @enter="enterBg" @appear="enterBg">
            <div class="fullheight  " v-for="(s,index) in slides" :key="s.header"
                 v-show="index===activeslide || activeslide ===-1 && index===0 || team "
                 v-touch:swipe.down="swipeHandler" v-on:wheel="wheelHandler">
                <Scrollbutton @click.native="goDown" :class="{active:activeslide>-1}"
                              v-if="activeslide +1 < slides.length && phase3" ></Scrollbutton>
                <div style="min-height: 100%;min-width: 100%;position: relative;">
                    <div class="slide d-flex align-items-stretch">
                        <div class="slidemenu "
                             :class="{active:activeslide>-1}">
                            <transition v-on:enter="enterLater">
                                <div class="menuitems" v-show="slidesActive()">
                                    <router-link v-for="(t,index) in slidemenu" class="menuitem"
                                                 :to="'/ueberuns/'+slugify(t)"
                                                 :class="{'active': checkActiveslide(index)}" :key="index">
                                        <div class="redcircle">
                                        </div>
                                        <div class="teaser h4">
                                            <!--                                            {{ t }}-->
                                        </div>
                                    </router-link>
                                    <!--                                    <router-link class="menuitem" to="/team" :class="{'active':team}">-->
                                    <!--                                        <div class="redcircle">-->
                                    <!--                                        </div>-->
                                    <!--                                        <div>-->
                                    <!--                                            Wir-->
                                    <!--                                        </div>-->
                                    <!--                                    </router-link>-->
                                </div>
                            </transition>
                        </div>
                        <transition v-on:enter="enter" v-on:leave="leaveBg">
                            <!--                        <transition >-->
                            <div class="slidecontent align-items-center d-flex"
                                 :class="{active:slidesActive(), team:team}" v-show="slidesActive()">
                                <!--                            <Team v-if="team"></Team>-->
                                <div>
                                    <h2 class="h2 zzgray slideheader">
                                        <div style="font-size: 28px;line-height: 34px;font-weight: 400;"
                                             v-if="s.second&&s.over" v-html="s.second">Test
                                        </div>
                                        <span v-html="s.header"></span>
                                        <div style="font-size: 28px;line-height: 34px;font-weight: 400;"
                                             v-if="s.second&&!s.over" v-html="s.second">Test
                                        </div>
                                    </h2>
                                    <div class="slidetext" v-html="s.text">
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div class="bg" :style="{ backgroundImage: `url(${findBg(s.hintergrund.url,activeslide)})` }"
                         v-if="!team"
                         :class="{active:activeslide>-1}">
                        &nbsp;
                        <!--                        <Team v-if="activeslide===slides.length"></Team>-->
                    </div>
                    <Start :anim.sync="startanim" phase3.sync="phase3" v-if="activeslide===-1"></Start>
                </div>
            </div>
        </transition-group>
        <!--        <div class="d-flex d-md-none">-->
        <!--            <Start :anim.sync="startanim" v-if="activeslide===-1"></Start>-->
        <!--            -->
        <!--        </div>-->
    </div>
</template>
<script>
    import store from '@/store'
    import Velocity from "velocity-animate";
    import Start from '@/components/Start.vue'
    import Team from '@/components/Team.vue'
    import Scrollbutton from '@/components/parts/Scrollbutton.vue'

    const slugify = require('slugify')
    export default {
        Velocity,
        store,
        components: {Start, Team, Scrollbutton},
        created: function () {
        },
        name: "Slides",
        data() {
            return {
                startanim: false,
                phase3: true
            }
        },
        mounted() {
            document.body.classList.add('nooverflow')
        },
        destroyed() {

        },
      watch: {
        activeslide() {
          console.log(this.activeslide)
            document.body.classList.add('nooverflow')

        }
      },
        methods: {
            wheelHandler(e) {
                if (e.deltaY > 0) {
                    if (this.slides.length > this.activeslide + 1) {
                        this.goDown();
                    } else if (this.slides.length === this.activeslide + 1) {
                        return false;
                    }
                }
                if (e.deltaY < 0) {
                    if (this.activeslide === 0) {
                        this.$router.push('/');
                    } else {
                        this.goUp()
                    }
                }
            },
            goUp() {
                this.$router.push({
                    name: 'Slides',
                    params: {slide: this.slugify(this.slidemenu[this.activeslide - 1])}
                })
            },
            goDown() {
                this.$router.push({
                    name: 'Slides',
                    params: {slide: this.slugify(this.slidemenu[this.activeslide + 1])}
                })
            },
            swipeHandler(e) {
                // e.deltaY > 0 ? this.slide++ : this.slide--;
            },
            slugify(str) {
                return str ? slugify(str, {lower: true}) : '';
            },
            enter(el, done) {
                el.velocity({
                    // transform: ['translateX(0)', 'translateX(-100%)'],
                    opacity: [1, 0],
                    // width: [50 % 0]
                }, {
                    duration: 1000,
                    delay: 0
                })
                done()
            },
            enterLater(el, done) {
                el.velocity({
                    transform: ['translateX(0)', 'translateX(-200%)'],
                    opacity: [1, 0],
                    width: [50 % 0]
                }, {
                    duration: 1500,
                    delay: 0
                })
                done()
            },
            enterBg(el) {
                let bg = el.querySelector('.bg');
                let cont = el.querySelector('.slidecontent')
                if (cont) {
                    cont.velocity({
                            opacity: [1, 0]
                        },
                        {
                            duration: 500,
                        })
                }
                if (bg) {
                    bg.velocity({
                            opacity: [1, 0]
                        },
                        {
                            duration: 500,
                        })
                }
            },
            leaveBg(el) {
                // let bg = el.querySelector('.bg');
                // let cont = el.querySelector('.slidecontent')
                // console.log(cont)
                el.velocity({
                        opacity: 0
                    },
                    {
                        duration: 500,
                    })
                // cont.velocity({
                //       opacity: 0
                //     },
                //     {
                //       duration: 500,
                //     })
                // bg.velocity({
                //       opacity: 0
                //     },
                //     {
                //       duration: 500,
                //     })
            },
            slidesActive() {
                return this.activeslide > -1
            },
            checkActiveslide(index) {
                return this.activeslide === index;
            },
            findBg(url, activeslide) {
                if (this.activeslide === -1) {
                    return this.slides[0].hintergrund.url;
                } else return url;
            }
        },
        computed: {
            slides: () => store.state.slides,
            slidemenu: () => store.state.slides.map(s => s.teaser),
            activeslide: function () {
                if (this.$route.meta.team === true) {
                    return this.slides.length
                }
                let slug = this.$route.params.slide
                let slides = store.state.slides.map(s => this.slugify(s.teaser))
                return slides.indexOf(slug) > -1 ? slides.indexOf(slug) : -1;
            },
            team: function () {
                return this.$route.meta.team
            },
        },
    }
</script>
<style scoped lang="scss">
    .fullheight {
        background-size: 30% auto;
        //min-height: 100%;
        background-repeat: no-repeat;
        background-position: 100% 0%;
        display: flex;
        align-items: stretch;
      overflow: hidden;
    }

    .slide {
      overflow: hidden;
        min-height: 100%;
        width: 100%;
        align-items: stretch;
        background-color: #f2f2f2;
    }

    .slideheader {
        max-width: 600px;
    }

    .slidetext {
        //styleName: <p> - copy BIG;
        max-width: 600px;
        font-size: 20px;
        //font-weight: 500;
        line-height: 29px;
        letter-spacing: 0.02em;
        text-align: left;
        font-family: $sans;
        color: $zzgray;
        @include tablet {
            font-size:18px;
            line-height: 22px;
        }
        @include mobile {
            font-size: 16px;
        }
    }

    h1 {
        @include mobile {
            font-size: 32px;
        }
    }

    .slidemenu {
        width: 0%;
        display: flex;
        align-items: center;
        justify-content: center;

        &.active {
            //opacity: 1;
            width: 20%;
            @include mobile {
                width: 10%;
            }
        }

        .menuitems {
            height: 50%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            border-left: 1px solid #B9B9B9;
            margin-left: 50px;

            .menuitem {
                .teaser {
                    display: none;
                }

                text-align: left;
                margin-left: -16px;
                font-weight: bold;
                font-size: 12px;
                line-height: 140%;
                text-transform: uppercase;
                letter-spacing: 0.1em;
                color: $zzgray;
                display: flex;
                align-items: center;

                .redcircle {
                    margin-right: 20px;
                    height: 32px;
                    width: 32px;
                    border-radius: 50%;
                    border: 2px solid $zzcolor;
                    background: #f2f2f2;
                    position: relative;

                    &:after {
                        content: '';
                        position: absolute;
                        height: 8px;
                        left: 10px;
                        top: 10px;
                        width: 8px;
                        transform: rotate(45deg);
                        background-color: $zzcolor;
                        //border: 1px solid $zzcolor;
                    }
                }

                &.active, &:hover {
                    .redcircle {
                        background-color: $zzcolor;

                        &:after {
                            background-color: #f8f8f8;
                        }
                    }

                    .teaser {
                        display: inline-flex;
                        @include mobile {
                            display: none;
                        }
                    }
                }
            }
        }
    }

    .slidecontent {
        width: 50%;

        & > div {
            opacity: 0;
        }

        transition: width 0s;
        overflow: hidden;

        &.active {
            width: 50%;
            padding: 0 100px;
            @include tablet {
            padding: 0 50px;

            }

            & > div {
                opacity: 1;
            }

            &.team {
                width: 50%;
            }

            @include mobile {
                width: 80%;
            }
        }

        align-self: stretch;
        text-align: left;
    }

    .bg {
        width: 50%;
        min-height: 100vh;
        position: absolute;
        top: 0;
        right: 0;
        transition: all 1s ease-out;
        flex-grow: 1000;
        align-self: stretch;
        /*background-position: 70% center;*/
        background-repeat: repeat;

        &.active {
            width: 30%;
            @include mobile {
                width: 0;
            }
        }

        //align-self: stretch;
        background-size: cover;
        background-position: center;
    }
</style>
